/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */
export default [
	// Indefinite articles:
	"برخی از", "یک", "ی", "مقداری", "چندتا", "معدود",
	// Numbers 1-10:
	"یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه", "ده",
	// Demonstratives:
	"همان", "همین", "آنها", "اینان", "آنان", "اینها", "این", "آن",
];
